import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class ConfigService {
    private baseApiUrl: any;
    private _enabledAppList: string[];
     private getMapProviderAuthURL = `${environment.API}${environment.RESOURCES.GET_MAP_PROVIDER_AUTH}`;

    constructor(private http: HttpClient, private cookieService: CookieService) {}

    async loadConfig(): Promise<void> {
        await this.http
            .get('./assets/appProperties/app.properties.json')
            .toPromise()
            .then((data: any) => {
                this.baseApiUrl = data.clientUrl;
                this._enabledAppList = data.enabledApps;
                this.getMapProviderAuthURL = `${this.baseApiUrl}${environment.RESOURCES.GET_MAP_PROVIDER_AUTH}`;
            });
        await this.renewMapProviderAuthCookie();
    }

    public get getBaseApiUrl(): string {
        return this.baseApiUrl;
    }

    get enabledAppList(): string[] {
        return this._enabledAppList;
    }

    public renewMapProviderAuthCookie() {
        return this.http.get(this.getMapProviderAuthURL).toPromise()
          .then((response: any) => {
            this.cookieService.set('gh', response.gs_h);
        });
    }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/utils/config.service.ts